/**
 * Utility classes restoring the rich-text elements Tailwind's preflight
 * resets inside `dangerouslySetInnerHTML` blocks (CMS descriptions): list
 * bullets/numbering + indent, paragraph rhythm and link underlines. Bold
 * (`<strong>`/`<b>`) is toned to weight 500 — the design uses medium, not the
 * browser-default 700.
 *
 * Headings (`h2`–`h4`) become medium sub-headings with breathing room so
 * editorial CMS content (e.g. a supplier's free-text "Awards" tab, grouped
 * under "Trusted brand", "Quality Service Award", …) reads as structured
 * sections rather than plain bold lines. Empty heading nodes — CMS authors
 * often leave `<h2></h2>` as spacers — are hidden so they don't double the gap.
 */
const RICH_TEXT_HEADING_CLASS =
    '[&_h2:empty]:hidden [&_h3:empty]:hidden [&_h4:empty]:hidden [&_h2]:mb-[0.5rem] [&_h2]:mt-[1.75rem] [&_h2]:font-medium [&_h2]:leading-snug [&_h2]:text-[1.375rem] [&_h3]:mb-[0.375rem] [&_h3]:mt-[1.5rem] [&_h3]:font-medium [&_h3]:leading-snug [&_h3]:text-[1.25rem] [&_h4]:mb-[0.375rem] [&_h4]:mt-[1.25rem] [&_h4]:font-medium [&>h2:first-child]:mt-0 [&>h3:first-child]:mt-0 [&>h4:first-child]:mt-0';

export const RICH_TEXT_HTML_CLASS =
    // `overflow-wrap:anywhere` so a long unbreakable token (e.g. a CMS author
    // pasting a raw URL as a "Care guide" value) wraps inside its cell instead of
    // forcing the whole page to scroll horizontally. `anywhere` (not
    // `break-word`) also shrinks min-content so the flex/grid column can narrow.
    // `font-medium!` (important): a global unlayered `b, strong { bolder }` reset
    // otherwise wins over the layered utility and renders bold (700) instead of 500.
    // B4: `[&_a]:underline-offset-2` and hover opacity so embedded links are
    // clearly distinguishable from surrounding text (e.g. description & scope of
    // use rich text where plain black `<a>` tags previously looked like text).
    '[overflow-wrap:anywhere] [&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-opacity [&_a:hover]:opacity-60 [&_b]:font-medium! [&_li+li]:mt-1 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-[2rem] [&_p+p]:mt-4 [&_p]:m-0 [&_strong]:font-medium! [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-[2rem] ' +
    RICH_TEXT_HEADING_CLASS;
